import { Schedule } from './schedule.model';
import { Message } from './message.model';
import { Auth } from './auth.model';
import { Content } from './content.model';
import { FAQ } from './faq.model';
import { User } from './user.model';
import { Sponsor } from './sponsor.model';
import { Child, Person, Roster } from '@/models/roster.model';
import { Wiki, WikiPage } from './wiki.model';
import { File } from './file.model';

export interface BazaarState {
  auth: Auth;
  schedule: Schedule[];
  scheduleItem: Schedule | null;
  messages: Message[];
  messageItem: Message | null;
  contents: Content[];
  contentItem: Content | null;
  sponsors: Sponsor[];
  sponsorItem: Sponsor | null;
  faqs: FAQ[];
  faqItem: FAQ | null;
  rosters: Roster[];
  roster: Roster | null;
  people: Person[];
  person: Person | null;
  children: Child[];
  users: User[];
  wiki: Wiki | null;
  editWiki: boolean;
  wikiPage: WikiPage | null;
  wikiPages: WikiPage[];
  wikiTemplates: WikiPage[];
  files: File[];
}

export enum Mutations {
  SetAuth = 'SetAuth',
  SetMessages = 'SetMessages',
  SetMessageItem = 'SetMessageItem',
  SetSchedules = 'SetSchedules',
  SetScheduleItem = 'SetScheduleItem',
  SetContents = 'SetContents',
  SetContentItem = 'SetContentItem',
  SetSponsors = 'SetSponsors',
  SetSponsorItem = 'SetSponsorItem',
  SetFAQs = 'SetFAQs',
  SetFAQItem = 'SetFAQItem',
  SetRosters = 'SetRosters',
  SetRoster = 'SetRoster',
  SetPeople = 'SetPeople',
  SetPerson = 'SetPerson',
  SetAsPerson = 'SetAsPerson',
  UnsetPerson = 'UnsetPerson',
  SetChildren = 'SetChildren',
  SetUsers = 'SetUsers',
  SetWiki = 'SetWiki',
  SetEditWiki = 'SetEditWiki',
  SetWikiPage = 'SetWikiPage',
  SetWikiPages = 'SetWikiPages',
  SetWikiTemplates = 'SetWikiTemplates',
  SetFiles = 'SetFiles',
}

export enum Actions {
  Register = 'Register',
  Login = 'Login',
  Logout = 'Logout',
  GetAuth = 'GetAuth',
  // schedules
  GetSchedules = 'GetSchedules',
  GetScheduleItem = 'GetScheduleItem',
  AddSchedule = 'AddSchedule',
  UpdateSchedule = 'UpdateSchedule',
  // messages
  GetMessages = 'GetMessages',
  GetMessageItem = 'GetMessageItem',
  AddMessage = 'AddMessage',
  UpdateMessage = 'UpdateMessage',
  // content
  GetContents = 'GetContents',
  GetContentItem = 'GetContentItem',
  AddContent = 'AddContent',
  UpdateContent = 'UpdateContent',
  // faq
  GetFAQs = 'GetFAQs',
  GetFAQItem = 'GetFAQItem',
  AddFAQ = 'AddFAQ',
  UpdateFAQ = 'UpdateFAQ',
  // wiki
  GetWikiPages = 'GetWikiPages',
  GetWiki = 'GetWiki',
  GetWikiById = 'GetWikiById',
  AddWikiPage = 'AddWikiPage',
  UpdateWikiPage = 'UpdateWikiPage',
  AddFile = 'AddFile',
  GetFiles = 'GetFiles',
  // rosters
  GetRosters = 'GetRosters',
  GetRosterItem = 'GetRosterItem',
  AddRoster = 'AddRoster',
  UpdateRoster = 'UpdateRoster',
  AddPersonToSlot = 'AddPersonToSlot',
  // people
  GetPeople = 'GetPeople',
  AddPerson = 'AddPerson',
  UpdatePerson = 'UpdatePerson',
  GetChildren = 'GetChildren',
  AddChild = 'AddChild',
  UpdateChild = 'UpdateChild',
  // sponsors
  GetSponsors = 'GetSponsors',
  GetSponsorItem = 'GetSponsorItem',
  AddSponsor = 'AddSponsor',
  UpdateSponsor = 'UpdateSponsor',
  // user
  GetUsers = 'GetUsers',
  UpdateUser = 'UpdateUser',
}
